import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Event } from '../models/event';
import { Statistic } from '../models/statistic';

@Injectable({
    providedIn: 'root',
})
export class SubscriptionService {
    constructor(private http: HttpClient) {}

    /**
     * Ruft eine Liste von Subscription-Produkten basierend auf der angegebenen Kategorie und dem Typ ab.
     *
     * @param {number} category - Die Kategorie-ID der gewünschten Subscription-Produkte.
     * @return {Observable<any>} Ein Observable, das die abgerufenen Subscription-Produkte enthält.
     */
    getSubscriptionProducts(category: number): Observable<any> {
        return this.http.get<any>(`${environment.appApi}/fakturia/packages/${category}`);
    }

    /**
     * Ruft die Verträge eines Benutzers ab.
     *
     * @return {Observable<any>} Ein Observable, das die Daten der Benutzerverträge liefert.
     */
    getUserContracts(): Observable<any> {
        return this.http.get<any>(`${environment.appApi}/user/contracts`);
    }

    async hasActiveContracts(): Promise<boolean> {
        const contracts = await firstValueFrom(this.getUserContracts());
        return contracts.length > 0;
    }

    /**
     * Beendet einen bestehenden Vertrag basierend auf der angegebenen contractId.
     *
     * @param {number} contractId Die eindeutige ID des Vertrags, der gekündigt werden soll.
     * @return {Observable<any>} Gibt ein Observable zurück, das die Antwort des Servers nach der Kündigung des Vertrags enthält.
     */
    terminateContract(contractId: number): Observable<any> {
        return this.http.post<any>(`${environment.appApi}/user/contracts/${contractId}/cancel`, {});
    }
}
